import styled from "styled-components";
import { LogoContainerCasino888Box } from "./logo-container.casino888.box";

export const LogoContainerCasino777Box = styled(LogoContainerCasino888Box)`

`;
